// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2AN8v","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2VBxf"};